<main class="dialog-content">
    <ng-content #dialogContainer></ng-content>
</main>